module.exports = __webpack_public_path__ + "assets/media/morning.acdb48c7.mp3";